import { StatusLabelTypes } from '@factorialco/deprecated-design-system'
import {
  FinanceValueObjectsFinancialDocumentTypeEnum,
  FinanceValueObjectsInvoiceStatusEnum,
  InvoiceFragment,
} from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { InvoiceType } from 'modules/finance/components/Invoices/Detail/Content/Form/types'

interface InvoiceEligibleToSendToPayFields {
  currency?: string | null
  status: FinanceValueObjectsInvoiceStatusEnum
  validatedAt?: string | null
}

export const invoiceStatusTagType = (
  status: FinanceValueObjectsInvoiceStatusEnum
): StatusLabelTypes => {
  switch (status) {
    case 'review':
    case 'processing':
      return 'neutral'
    case 'sent_to_pay':
      return 'info'
    case 'paid':
      return 'positive'
    default:
      return status satisfies never
  }
}
export const mapStatusText = (key: FinanceValueObjectsInvoiceStatusEnum) => {
  switch (key) {
    case 'review':
      return i18n.t('finance.invoices.list.status.pending')
    case 'processing':
      return i18n.t('finance.invoices.list.status.processing')
    case 'paid':
      return i18n.t('finance.invoices.list.status.paid')
    case 'sent_to_pay':
      return i18n.t('finance.invoices.list.status.sent_to_pay')
    default:
      throw Error(`Missing value for status ${key}`)
  }
}

export const mapDocumentTypeText = (key: FinanceValueObjectsFinancialDocumentTypeEnum) => {
  switch (key) {
    case 'invoice':
      return i18n.t('finance.invoices.list.document_type.invoice')
    case 'receipt':
      return i18n.t('finance.invoices.list.document_type.receipt')
    case 'credit_note':
      return i18n.t('finance.invoices.list.document_type.credit_note')
    default:
      throw Error(`Missing value for status ${key}`)
  }
}

export const isInvoiceEligibleToSendToPay = (
  invoice: InvoiceFragment | InvoiceEligibleToSendToPayFields
) =>
  invoice.status != 'sent_to_pay' &&
  invoice.status != 'paid' &&
  invoice.validatedAt != null &&
  invoice.currency == 'EUR'

export const isInvoiceEligibleToDoAccounting = (invoice: InvoiceFragment) =>
  invoice.validatedAt != null

export const isInvoiceDeletable = (invoice: InvoiceType) =>
  canUpdateInvoiceData(invoice) &&
  invoice.purchaseOrderFinancialDocumentAssociation == null &&
  invoice.expensesFinancialDocumentAssociation == null &&
  invoice.softwareSetupFinancialDocumentAssociation == null

export const canUpdateInvoiceData = (invoice: InvoiceFragment) => invoice.validatedAt == null

export const saleInvoiceStatusTagType = (
  validated?: boolean,
  registered?: boolean
): StatusLabelTypes => {
  if (!validated && !registered) {
    return 'neutral'
  }

  if (validated) {
    return 'info'
  }

  if (registered) {
    return 'warning'
  }

  return 'neutral'
}

export const mapSaleInvoiceStatusText = (validated?: boolean, registered?: boolean) => {
  if (!validated && !registered) {
    return i18n.t('finance.sale_invoices.status.draft')
  }

  if (validated) {
    return i18n.t('finance.sale_invoices.status.issued')
  }

  if (registered) {
    return i18n.t('finance.sale_invoices.status.processing')
  }

  return ''
}

export const formatTaxRate = (taxRatePercentage?: number | null): string => {
  if (!taxRatePercentage && taxRatePercentage !== 0) return ''
  const factor = Math.pow(10, 2)
  const percentageRate = Math.round(taxRatePercentage * 100 * factor) / factor

  return `${percentageRate}%`
}
